import { Chip } from '@mui/material';
import { useTranslation } from 'react-i18next';

/** Active / inactive badge, used in every master-data list. */
export function StatusChip({ active }: { active: boolean }) {
  const { t } = useTranslation();

  return (
    <Chip
      size="small"
      label={active ? t('common.active') : t('common.inactive')}
      color={active ? 'success' : 'default'}
      variant={active ? 'filled' : 'outlined'}
    />
  );
}
